export default __webpack_public_path__ + "static/media/gwn34.6e84e5f4.webp";